import styled from 'styled-components';
import { DESKTOP_MEDIA_QUERY, MOBILE_MEDIA_QUERY } from '~/constants';
import desktopBackGroundImage from '~/assets/recruit_page/desktop_recruit_page_visual.png';
import { hideOnDesktop, hideOnMobile } from '~/utils/styles';

type LetterSpacingProps = {
  readonly letterSpacing: number;
};

type MobilePaddingProps = {
  readonly paddingBottom: number;
};

export const RecruitMainWrapper = styled.div`
  width: 100%;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 9.72%;
    background-image: url(${desktopBackGroundImage});
    background-repeat: no-repeat;
    background-size: cover;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 15.6%;
  }
`;

export const RecruitBoard = styled.div`
  background-color: #eaeeee;
  color: #050825;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 75%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 92%;
  }
`;

export const MobileTopVisual = styled.img`
  ${hideOnDesktop()}

  width: 100%;
`;

export const ContentsBoard = styled.div`
  position: relative;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 74.07%;
    padding-top: 10%;
    padding-bottom: 6.67%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 85.46%;
    padding-top: 5.05%;
    padding-bottom: 5.94%;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  position: absolute;
  text-align: center;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 2.08vw;
    top: -0.4em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 4vw;
    top: -7.6em;
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  letter-spacing: 0.2em;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 2.08vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 4vw;
  }
`;

export const TitleJP = styled.h2`
  font-weight: 700;
  letter-spacing: 0.3em;
  color: #ff9000;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 1.25vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.4vw;
  }
`;

export const Category = styled.p`
  font-weight: 700;
  letter-spacing: 0.2em;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 2.5vw;
    padding-bottom: 1.3em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 4.79vw;
    padding-bottom: 1.31em;
  }
`;

export const TopicContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 1.25vw;
    padding-bottom: 1em;
  }

  ${MOBILE_MEDIA_QUERY} {
    position: relative;
    font-size: 2.4vw;
    padding-bottom: 1.45em;
  }
`;

export const TopicTitle = styled.p`
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #ff9000;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 1.25vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.4vw;
  }
`;

export const LongHorizontalLine = styled.div`
  border-top: 2px solid #687e7b;

  ${DESKTOP_MEDIA_QUERY} {
    width: 86.25%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 94.91%;
    position: absolute;
    right: -13.08%;
  }
`;

export const ShortHorizontalLine = styled.div`
  border-top: 2px solid #687e7b;

  ${DESKTOP_MEDIA_QUERY} {
    width: 77.97%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 83.73%;
    position: absolute;
    right: -13.08%;
  }
`;

export const JobDetail = styled.p`
  width: 100%;
  text-align: justify;
  font-weight: 300;
  letter-spacing: 0.3em;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.97vw;
    line-height: 1.71;
    padding-bottom: 1.6em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.13vw;
    line-height: 1.5;
    padding-bottom: 1.6em;
  }
`;

export const Theme = styled.p`
  width: 100%;
  font-weight: 700;
  letter-spacing: 0.3em;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.83vw;
    padding-bottom: 1.66em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.12vw;
    line-height: 1.38;
    padding-bottom: 1em;
  }
`;

export const RequirementsContainer = styled.div`
  width: 100%;

  ${DESKTOP_MEDIA_QUERY} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.82vw;
    padding-bottom: 4.17em;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.13vw;
    padding-bottom: 3.44em;
  }
`;

export const RequirementsDetailBox = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    width: 50%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 90%;
    padding-bottom: 3.2%;
  }
`;

export const RequirementsDetailRightBox = styled.div`
  width: 47.03%;

  ${MOBILE_MEDIA_QUERY} {
    width: 90%;
  }
`;

export const MobileRequirementsDetailBox = styled.div`
  ${hideOnDesktop()}
  width: 90%;
  padding-bottom: 3.2%;
`;

export const RequirementsDetail = styled.p<LetterSpacingProps>`
  font-weight: 300;
  letter-spacing: ${(props) => props.letterSpacing}em;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.82vw;
    line-height: 2;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.13vw;
    line-height: 1.5;
  }
`;

export const DesktopSingleRequirementsDetail = styled.p`
  ${hideOnMobile()}

  font-size: 0.82vw;
  font-weight: 300;
  letter-spacing: 0.3em;
  line-height: 2;
  padding-bottom: 1em;
`;

export const ApplicationContainer = styled.div`
  width: 100%;
  background-color: #ffffff;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 3.86%;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 4.41%;
  }
`;

export const ApplicationTitle = styled.p`
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #ff9000;
  padding-bottom: 1.39em;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 1.25vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 2.4vw;
  }
`;

export const ApplicationDescription = styled.p`
  font-weight: 300;
  letter-spacing: 0.3em;
  color: #050825;
  padding-bottom: 1.5em;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 84.22%;
    font-size: 0.83vw;
    line-height: 1.5;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 89%;
    font-size: 2.13vw;
    line-height: 1.125;
  }
`;

export const ApplicationAddress = styled.p<MobilePaddingProps>`
  font-weight: 700;
  letter-spacing: 0.3em;
  color: #050825;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 84.22%;
    font-size: 0.83vw;
    line-height: 1.5;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 89%;
    font-size: 2.13vw;
    line-height: 1.125;
    padding-bottom: ${(props) => props.paddingBottom}%;
  }
`;

export const MobileBr = styled.br`
  ${hideOnDesktop()}
`;

export const ApplicationEmail = styled.p`
  ${hideOnMobile()}

  width: 84.22%;
  font-size: 0.83vw;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.3em;
  color: #050825;
  margin: 0 auto;
  padding-bottom: 6.16%;
`;

export const EmailButtonContainer = styled.a`
  display: flex;
  flex-direction: row;
  text-decoration: none;
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 47.5%;
    padding-bottom: 3.75%;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 64.4%;
    padding-bottom: 5.76%;
  }
`;

export const LeftSideBox = styled.div`
  width: 21.05%;
  position: relative;
  background-color: #d8e6e3;
`;

export const ArrowContainer = styled.div`
  width: 100%;
  padding-top: 100%;
`;

export const Arrow = styled.img`
  width: 20%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const RightSideBox = styled.div`
  width: 78.95%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff9000;
`;

export const TextBox = styled.p`
  width: 100%;
  text-align: center;
  font-weight: 300;
  letter-spacing: 0.6em;
  color: #ffffff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.86vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 1.64vw;
  }
`;
